/**
 * StatusBadge — single canonical status pill for every roster phase.
 *
 * Replaces the local RosterStatusBadge / ContentTableStatusPill components
 * that were duplicated in each tab. All tabs import this one component so
 * label wording and colour tokens stay in sync automatically.
 */

import { STATUS_MAP } from './statusMap';

export function StatusBadge({ status }: { status: string }) {
  const { label, cls, dot } = STATUS_MAP[status] ?? {
    label: status.replace(/_/g, ' '),
    cls: 'bg-stone-100 text-stone-700',
  };
  // Figma status pill (node 905:20702): borderless soft pill, 12px DM Sans
  // Medium uppercase, px-3 py-[5px], rounded-full. "Live" carries a green dot
  // (Figma "● LIVE"); our labels are kept.
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-[5px] text-[12px] font-medium uppercase ${cls}`}
    >
      {dot && <span className={`size-1.5 shrink-0 rounded-full ${dot}`} />}
      {label}
    </span>
  );
}
